/* <hy-count-up data-to="150">150</hy-count-up>: when it scrolls into view, counts 0 -> N in 1s
   (100 steps of 10ms, integer steps), like jQuery counterUp (delay 10, time 1000) on the old page. */
(() => {
  if (customElements.get('hy-count-up')) return;
  const run = (el) => {
    const to = parseInt(el.dataset.to, 10);
    if (!(to > 0)) return;
    const steps = 100, nums = [];
    for (let i = steps; i >= 1; i--) nums.unshift(parseInt(to / steps * i, 10));
    el.textContent = '0';
    const tick = () => { el.textContent = nums.shift(); if (nums.length) setTimeout(tick, 10); };
    setTimeout(tick, 10);
  };
  const io = 'IntersectionObserver' in window && new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); run(e.target); } });
  });
  customElements.define('hy-count-up', class extends HTMLElement {
    connectedCallback() { if (io && !matchMedia('(prefers-reduced-motion: reduce)').matches) io.observe(this); }
    disconnectedCallback() { if (io) io.unobserve(this); }
  });
})();
